import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Loading from '../CoreNursingSkillVideo/Loading';
import { Container } from '@mui/material';

import MuiDialog from 'components/MuiDialog';
import {
  SurveyDialogProps,
  TSubmitAssignmentDefaultValues,
} from 'routes/Main/Survey/type';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';
import useUser from 'store/user/useUser';
import useStudent from 'store/student/useStudent';
import StudentInfo from '../CoreNursingSkillVideo/StudentModeInfo';
import ProfModeInfo from '../CoreNursingSkillVideo/ProfModeInfo';

import axios from 'axios';
import AssignmentVideoForm from './AssignmentVideoForm';

const SubmitAssignment = (
  props: SurveyDialogProps<TSubmitAssignmentDefaultValues>
) => {
  const [refresh, setRefresh] = useState(false);
  const [totalSize, setTotalSize] = useState(0);
  const { isStudent } = useUser();
  const { student_uuid } = useStudent();
  const [loading, setLoading] = useState(false);

  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const { handleSubmit, register, getValues, setValue, watch } = useForm({
    defaultValues,
  });

  const onSubmit = async (data: TSubmitAssignmentDefaultValues) => {
    const { file, file2, file3 } = data;
    setLoading(true);

    // 제출할 파일이 있는지 확인
    const filesToSubmit = [file?.[0], file2?.[0], file3?.[0]].filter(f => f);
    if (filesToSubmit.length === 0) {
      onUpdateIsSave(true);
      setLoading(false);
      onSuccess('저장되었습니다');
      return;
    }

    const formData = new FormData();

    // 각 파일이 존재하는 경우에만 formData에 추가
    if (file?.[0]) {
      formData.append('file', file[0]);
    }
    if (file2?.[0]) {
      formData.append('file2', file2[0]);
    }
    if (file3?.[0]) {
      formData.append('file3', file3[0]);
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/file/assignment_upload?user_id=${user_id}&patient_id=${patientInfo.patient_id}`,
        formData,
        {
          headers: {
            Accept: 'application/json',
            'Content-type':
              'multipart/form-data;charset=UTF-8; boundary=6o2knFse3p53ty9dmcQvWAIx1zInP11uCfbm',
          },
        }
      );

      onUpdateIsSave(true);
      setLoading(false);
      onSuccess('저장되었습니다');
      setRefresh(!refresh);
    } catch (error) {
      onFail('저장에 실패하였습니다', error);
      setLoading(false);
    }
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onSuccess,
    onRequired,
  };

  return (
    <MuiDialog.SurveyFormTwo
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Container maxWidth="md" sx={{ mt: 7.5, mb: 9, height: '350px' }}>
        {isStudent ? (
          <StudentInfo totalSize={totalSize} />
        ) : (
          <ProfModeInfo totalSize={totalSize} />
        )}
        {loading ? (
          <Loading />
        ) : (
          <AssignmentVideoForm
            {...formProps}
            user_id={isStudent ? user_id : student_uuid}
            patient_id={patientInfo.patient_id}
            patient_name={patientInfo.name}
            totalSize={totalSize}
            setTotalSize={setTotalSize}
            refresh={refresh}
          />
        )}

        {/* <VideoForm {...formProps} user_id={isStudent ? user_id : student_uuid} patient_id={patientInfo.patient_id} patient_name={patientInfo.name} totalSize={totalSize} setTotalSize={setTotalSize} refresh={refresh} /> */}
      </Container>
    </MuiDialog.SurveyFormTwo>
  );
};

export default SubmitAssignment;
